import React, { use, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: 700, md: 1000 }, // Responsive: 90% on mobile, 700px on tablet, 1000px on desktop
  maxWidth: "95vw", // Never exceed 95% of viewport width
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const tableStyling = {
  padding: "4px 8px",
  lineHeight: "1.75rem",
  textAlign: "center" as const,
  fontSize: "12px",
  height: "38px",
};

const thirtCell = {
  maxWidth: "200px",
  textAlign: "left" as const,
};

const bigCell = {
  width: "130px",
  textAlign: "left" as const,
};

const headerTable = {
  backgroundColor: "#000",
  borderBottom: "2px solid #e0e0e0",
  FontWeight: "900",
};

const PlayByPlay = ({ game, homeTeam, awayTeam }) => {
  const [gameId, setGameId] = useState(game ? game.id : null);
  const [plays, setPlays] = useState([]);
  const [playsType, setPlaysType] = useState([]);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [selectedVideoUrl, setSelectedVideoUrl] = React.useState(null);
  const handleOpen = (videoUrl) => {
    setSelectedVideoUrl(videoUrl);
    setIsModalOpen(true);
  };
  const handleClose = () => {
    setIsModalOpen(false);
    setSelectedVideoUrl(null);
  };

  useEffect(() => {
    console.log("Game plays data is undefined or null:", game?.plays || []);
    if (game && game.plays) {
      console.log("game.plays is an array:", Array.isArray(game.plays));
      setPlays(game.plays);
    } else {
      console.log("game.plays is not an array or is undefined:", game?.plays);
      setPlays([]);
    }
  }, [game]);

  const filteredPlays = plays
    .filter(
      (play) =>
        play.typeDescKey === "goal" ||
        play.typeDescKey === "penalty" ||
        play.typeDescKey === "period-start",
    )
    .map((play, index) => {
      const scoringPlayer =
        play.typeDescKey !== "period-start" && game?.rosterSpots
          ? game.rosterSpots.find(
              (spot) =>
                spot.playerId === play.details.scoringPlayerId ||
                spot.playerId === play.details.committedByPlayerId ||
                spot.playerId === play.details.servedByPlayerId,
            )
          : null;

      const firstAssistPlayerId =
        play.typeDescKey === "goal" && game?.rosterSpots
          ? game.rosterSpots.find(
              (spot) => spot.playerId === play.details.assist1PlayerId,
            )
          : null;

      const secondAssistPlayerId =
        play.typeDescKey === "goal" && game?.rosterSpots
          ? game.rosterSpots.find(
              (spot) => spot.playerId === play.details.assist2PlayerId,
            )
          : null;

      const videoLinkPlayer =
        play.typeDescKey === "goal"
          ? play.details.highlightClipSharingUrl
          : null;

      const videoId = videoLinkPlayer ? videoLinkPlayer.slice(-13) : null;

      const videoReaderUrl = videoId
        ? `https://players.brightcove.net/6415718365001/D3UCGynRWU_default/index.html?videoId=${videoId}`
        : null;

      const isPeriodStart = play.typeDescKey === "period-start";

      const determineGoalType = (
        amountOfplayer,
        eventOwnerTeamId,
        homeTeam,
        period,
      ) => {
        const scoringTeamId = eventOwnerTeamId;
        const isHomeTeamScoring = scoringTeamId === homeTeam.id;

        // Get the number of players on the ice for both teams
        const homePlayersOnIce = parseInt(amountOfplayer.toString()[2], 10);
        const awayPlayersOnIce = parseInt(amountOfplayer.toString()[1], 10);

        // Determine if it's a power play or shorthanded goal
        if (isHomeTeamScoring) {
          if (homePlayersOnIce > awayPlayersOnIce && awayPlayersOnIce < 5) {
            return "Power Play Goal";
          } else if (
            homePlayersOnIce < awayPlayersOnIce &&
            homePlayersOnIce < 5
          ) {
            return "Shorthanded Goal";
          } else if (
            homePlayersOnIce > awayPlayersOnIce &&
            homePlayersOnIce == 6
          ) {
            return "Goal with extra man";
          } else if (
            homePlayersOnIce < awayPlayersOnIce &&
            awayPlayersOnIce == 6
          ) {
            return "Empty Net Goal";
          }
        } else {
          if (awayPlayersOnIce > homePlayersOnIce && homePlayersOnIce < 5) {
            return "Power Play Goal";
          } else if (
            awayPlayersOnIce < homePlayersOnIce &&
            awayPlayersOnIce < 5
          ) {
            return "Shorthanded Goal";
          } else if (
            awayPlayersOnIce > homePlayersOnIce &&
            awayPlayersOnIce == 6
          ) {
            return "Goal with extra man";
          } else if (
            awayPlayersOnIce < homePlayersOnIce &&
            homePlayersOnIce == 6
          ) {
            return "Empty Net Goal";
          }
        }

        return "Goal"; // Regular goal
      };

      return (
        <>
          {isPeriodStart && (
            <TableRow>
              <TableCell
                colSpan={4}
                sx={{
                  ...tableStyling,
                  fontWeight: "bold",
                  backgroundColor: "#757575",
                  textAlign: "left",
                }}
              >
                {play.periodDescriptor.number != 4 &&
                play.periodDescriptor.number != 5
                  ? "Period " + play.periodDescriptor.number
                  : play.periodDescriptor.number == 4
                    ? "Over Time"
                    : "Shootout"}
              </TableCell>
            </TableRow>
          )}
          {!isPeriodStart && (
            <TableRow key={index}>
              <TableCell sx={{ ...tableStyling }}>
                {play.timeInPeriod}
              </TableCell>
              <TableCell sx={{ ...tableStyling, ...thirtCell }}>
                {play.typeDescKey === "goal" ? (
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleOpen(videoReaderUrl);
                    }}
                    style={{
                      textDecoration: "none",
                      fontWeight: "bold",
                      color: "inherit",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.textDecoration = "underline")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.textDecoration = "none")
                    }
                  >
                    {determineGoalType(
                      play.situationCode,
                      play.details.eventOwnerTeamId,
                      homeTeam,
                      play.periodDescriptor.number,
                    )}{" "}
                    <OndemandVideoIcon
                      sx={{ fontSize: 10, textAlign: "baseline" }}
                    />
                  </a>
                ) : (
                  <>
                    {play.typeDescKey}
                    {play.typeDescKey === "penalty" &&
                      ` ${play.details.duration} min for ${play.details.descKey}`}
                  </>
                )}
              </TableCell>
              <TableCell sx={{ ...tableStyling }}>
                <Link to={`/player/${scoringPlayer?.playerId}`}>
                  <span className={play.typeDescKey == "goal" ? "bold" : ""}>
                    #{scoringPlayer?.sweaterNumber}{" "}
                    {scoringPlayer?.firstName.default}{" "}
                    {scoringPlayer?.lastName.default}
                  </span>
                </Link>
                {firstAssistPlayerId ? ", " : ""}
                {firstAssistPlayerId?.firstName.default}{" "}
                {firstAssistPlayerId?.lastName.default}{" "}
                {secondAssistPlayerId ? ", " : ""}
                {secondAssistPlayerId?.firstName.default}{" "}
                {secondAssistPlayerId?.lastName.default}
              </TableCell>
              <TableCell sx={{ ...tableStyling }}>
                <Link
                  to={`/team/${play.details.eventOwnerTeamId == homeTeam.id ? homeTeam.abbrev : awayTeam.abbrev}`}
                >
                  {play.details.eventOwnerTeamId == homeTeam.id
                    ? homeTeam.commonName.default
                    : awayTeam.commonName.default}
                </Link>
              </TableCell>
            </TableRow>
          )}
        </>
      );
    });

  if (!homeTeam || !awayTeam || !homeTeam.id || !awayTeam.id) {
    return (
      <div className="teamContent table">
        <div className="title">Play By Play</div>
        <div style={{ padding: "20px", textAlign: "center" }}>
          Loading play-by-play data...
        </div>
      </div>
    );
  }

  return (
    <div className="teamContent table">
      <div className="title">Play By Play</div>

      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ ...headerTable }}>
            <TableRow>
              <TableCell sx={{ ...tableStyling }}>Time</TableCell>
              <TableCell sx={{ ...tableStyling }}>Play</TableCell>
              <TableCell sx={{ ...tableStyling }}>Player</TableCell>
              <TableCell sx={{ ...tableStyling }}>team</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{filteredPlays}</TableBody>
        </Table>
      </TableContainer>

      <Modal
        open={isModalOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <iframe
            title="Play Details"
            width="100%"
            height="500px"
            src={selectedVideoUrl}
          ></iframe>
        </Box>
      </Modal>
    </div>
  );
};

export default PlayByPlay;
